/**
 * Flood Center web v3 talks to two Firebase projects:
 *
 *   site  REACT_APP_FIREBASE_*       the v3 project: Hosting, alert_subscriptions, Auth, Analytics
 *   data  REACT_APP_DATA_FIREBASE_*  floodcenter-backend-v2: sensor, forecast and alert data, read only
 *
 * The site project may never be production or v2, so signups can only land in v3.
 * The data app is never signed in, so v2's rules reject any write from it.
 */
export const PRODUCTION_PROJECT_ID = 'floodcenter-backend';
export const V2_PROJECT_ID = 'floodcenter-backend-v2';

const PROTECTED_PROJECT_IDS = [PRODUCTION_PROJECT_ID, V2_PROJECT_ID];

/** Returns a message describing what is wrong with the two configs, or null. */
export function firebaseConfigProblem({ site, data }) {
  if (!site || !site.projectId || !site.apiKey) {
    return 'Missing REACT_APP_FIREBASE_* settings for the v3 project. Copy .env.example to '
      + '.env.local, fill in the web config, and restart the dev server.';
  }
  if (PROTECTED_PROJECT_IDS.includes(site.projectId)) {
    return `REACT_APP_FIREBASE_PROJECT_ID is ${site.projectId}. Flood Center v3 stores signups `
      + 'and is hosted in its own project, never in floodcenter-backend or floodcenter-backend-v2.';
  }
  if (!data || !data.projectId || !data.apiKey) {
    return 'Missing REACT_APP_DATA_FIREBASE_* settings for the data project '
      + `(${V2_PROJECT_ID}). Fill them in .env.local and restart the dev server.`;
  }
  if (data.projectId === PRODUCTION_PROJECT_ID) {
    return `REACT_APP_DATA_FIREBASE_PROJECT_ID is ${PRODUCTION_PROJECT_ID} (production). `
      + `Read sensor data from ${V2_PROJECT_ID}.`;
  }
  return null;
}
